export default __webpack_public_path__ + "static/media/Yurt1.1083c297.jpg";